export const materias = (idcurso) => {
    window.console.log('idcurso',idcurso)
    if(idcurso == 7919){
        return { //DISEÑO GRÁFICO INTEGRAL
            primer_anio: [
            'Técnicas de Estudio',
            'Psicología de la Comunicación',
            'Diseño Computarizado I',
            'Teoría de la Comunicación',
            'Diseño Computarizado II',
            'Teoría de la Imagen',
            'Fundamentos de Diseño',
            'Fundamentos de Marketing',
            'Inglés Técnico I',
            'Fundamentos de Administracion',
          ],
          segundo_anio: [
            'Taller de Fotografía',
            'Diseño Computarizado III',
            'Inglés Técnico II',
            'Dibujo para Diseño Gráfico',
            'Diseño e Imagen Corporativa',
            'Diseño Computarizado IV',
            'Taller de Televisión',
            'Diseño de Páginas Web',
            'Expresión en Diseño e Imagen'
          ],
          tercer_anio: [
            'Tipografía',
            'Diseño Multimedia I',
            'Diseño y Publicidad',
            'Arte y Diseño Contemporáneo',
            'Diseño Multimedia II',
            'Diseño Computarizado V',
            'Taller de Grado I',
            'Taller de Grado II', 
          ],
          cuarto_anio:[]
        }
    }
    else if(idcurso == 7921){
        return { // CONTADURÍA GENERAL
          primer_anio: [
            'Contabilidad I',
            'Matemática Financiera',
            'Informática Contable',
            'Administración General',
            'Legislación Laboral y Seguridad Social Aplicada',
            'Economía General Aplicada',
            'Documentos Comerciales y Mercantiles',
            'Estadística Aplicada',
            'Inglés Técnico ',
          ],
          segundo_anio: [
            'Contabilidad II',
            'Contabilidad de Costos I',
            'Contabilidad de Sociedades',
            'Contabilidad de Seguros',
            'Contabilidad Bancaria y Cooperativas',
            'Emprendimiento Productivo',
            'Sistema Tributario',
          ],
          tercer_anio: [
            'Contabilidad Agropecuaria',
            'Contabilidad de Costos II',
            'Contabilidad Gubernamental',
            'Contabilidad Extractiva (Minera, Petrolera y Forestal)',
            'Contabilidad de Servicios (Construcción, Hotelería y Transporte)',
            'Gabinete Contable Informático',
            'Análisis e Interpretación de Estados Financieros',
            'Taller de Modalidad de Graduación',
          ],
          cuarto_anio:[]
        }
    }
    else if(idcurso == 7917){
        return { //  MERCADOTECNIA
          primer_anio: [
            'Fundamentos de Mercadotecnia',
            'Comportamiento del Consumidor',
            'Servicio y Atención al Cliente',
            'Informática Aplicada a la Mercadotecnia',
            'Ingles Técnico de Mercadotecnia',
            'Análisis Económico y Contabilidad Aplicada a la Mercadotecnia',
            'Estadística Aplicada a la Mercadotecnia',
            'Introducción a Técnicas de Ventas',
          ],
          segundo_anio: [
            'Gestión de producto y Marca',
            'Determinación de Costos para la Fijación de Precios',
            'Gestión de Distribución',
            'Publicidad y Producción Audiovisual',
            'Mercadotecnia Publica de Servicios y Social',
            'Diseño Gráfico Publicitario',
            'Investigación de Mercados',
            'Mercadotecnia Directa y Relaciones Publicas',
          ],
          tercer_anio: [
            'Dirección y Promoción de Ventas',
            'Mercadotecnia Estratégica',
            'Mercadotecnia Internacional',
            'Mercadotecnia Relacional y CRM',
            'Marketing Digital',
            'Emprendimiento Productivo',
            'Taller de Modalidad de Graduación',
            'Análisis de la Competencia y Técnicas de Negociación',
          ],
          cuarto_anio:[]
        }
    }
    else if(idcurso == 7923){
        return { //  secretariado ejec
          primer_anio: [
            'Gestión Secretarial I',
            'Gramática Normativa',
            'Redacción y Correspondencia I',
            'Ofimática I',
            'Documentos Mercantiles ',
            'Archivística Física y Digital',
            'Idioma Originario I',
            'Mecanografía Computarizada',
            'Ingles Comercial I ',
          ],
          segundo_anio: [
            'Gestión Secretarial II',
            'Ingles Comercial II',
            'Redacción y Correspondencia II',
            'Ofimática II',
            'Contabilidad I',
            'Relaciones Humanas y Ética Profesional',
            'Idioma Originario II',
            'Gestión Documental y Archivo',
          ],
          tercer_anio: [
            'Administración Organizacional y Medio Ambiente',
            'Ingles Empresarial',
            'Redacción y Correspondencia III',
            'Taller de Modalidad de Graduación',
            'Contabilidad II',
            'Relaciones Publicas y Organización de Eventos',
          ],
          cuarto_anio:[]
        }
    }
    else if(idcurso == 7916){
        return { //  sistemas inform
          primer_anio: [
            'Matemática para la Informática',
            'Programación I',
            'Ingles Técnico',
            'Hardware de Computadoras',
            'Taller de Sistemas Operativos',
            'Ofimática y Tecnología Multimedia',
            'Diseño y Programación Web I', 
          ],
          segundo_anio: [
            'Estadística',
            'Programación II',
            'Estructura de Datos',
            'Redes de Computadoras I',
            'Programación para Dispositivos Móviles I',
            'Análisis y Diseño de Sistemas I',
            'Diseño y Programación Web II',
            'Base de Datos I',
          ],
          tercer_anio: [
            'Emprendimiento Productivo',
            'Diseño y Programación Web III',
            'Gestión y Mejoramiento de la Calidad de Software',
            'Redes de Computadoras II',
            'Taller de Modalidad de Graduación',
            'Análisis y Diseño de Sistemas II',
            'Programación para Dispositivos Móviles II',
            'Base de Datos II',
          ],
          cuarto_anio:[]
        }
    }
    else if(idcurso == 7918){
        return { //  telecomunicaciones REVISAR ES POR SEMESTRE
          primer_anio: [
            'Matemática para la Electrónica I',
            'Análisis de Circuitos I',
            'Física para la Electrónica ',
            'Instrumentos y Componentes',
            'Seguridad Industrial y Medio Ambiente',
            'Instalaciones Eléctricas',
          ],
          segundo_anio: [
            'Matemática para la Electrónica I',
            'Análisis de Circuitos I',
            'Física para la Electrónica ',
            'Instrumentos y Componentes',
            'Seguridad Industrial y Medio Ambiente',
            'Instalaciones Eléctricas',
          ],
          tercer_anio: [
            'Líneas de Transmisión y Antenas',
            'Maquinas Eléctricas',
            'Electrónica II',
            'Electrónica Digital II',
            'Programación II',
            'Arquitectura y Mantenimiento de Computadoras',
          ],
          cuarto_anio:[
            'Sistemas de Telecomunicaciones I',
            'Electroacústica',
            'Electrónica Industrial',
            'Mantenimiento de Equipos Electrónicos',
            'Sistemas de Telefonía Fija y Movil',
            'Microcontroladores I',
            'Taller de Modalidad de Grado',
          ]
        }
    }
    else if(idcurso == 7922){
        return { //  administracion de empresas
          primer_anio: [
            'Fundamentos de la Administración',
            'Contabilidad General Para Administraciones',
            'Matemática Financiera',
            'Estadística Para los Negocios',
            'Practica Laboral y Tributaria',
            'Informática Empresarial',
            'Inglés Técnico',
          ],
          segundo_anio: [
            'Organización de la Administración',
            'Investigación y Estrategia de Mercado',
            'Administración de Operaciones',
            'Gestión del Talento Humano',
            'Administración Financiera I',
            'Preparación y Evaluación de Proyectos',
            'Administración de Costos y Presupuestos',
            'Economía de la Empresa',
          ],
          tercer_anio: [
            'Administración de la Micro y Pequeña y Mediana Empresa',
            'Incubación y Modelos de Negocios',
            'Administración Financiera II',
            'Taller de Modalidad de Grado',
            'Emprendimiento Productivo',
            'Comercio Internacional',
            'Gestión Estratégica',
          ],
          cuarto_anio:[]
        }
    }
    else return {
        primer_anio:[],
        segundo_anio:[],
        tercer_anio:[]
    }
}